import { createContext } from "react";

const ComponentContext = createContext({});

export default ComponentContext;
